import { useUsersTableContext } from '@aibees/elephant/feature/account-magement-drawer/context';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import { Tab } from '../tab-drawer';
import { BillingTab } from './components/billing-tab';
import { CompanyTab } from './components/company-tab';
import { FooterNavigation } from './components/footer-navigation';
import { HeaderNavigation } from './components/header-navigation';
import { InformationCard } from './components/information-card';
import { OverviewTab } from './components/overview-tab';
import { UsersTab } from './components/users-tab';
import { ChangeProvider } from './context/change-tracker';
import { user } from './mockData';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountManagementDrawerProps as Props } from './types';

export const AccountManagementDrawer = memo(({ className }: Props) => {
  const { sidebarState, onCloseSidebar } = useUsersTableContext();

  const [tabs, setTabs] = useState<Tab[]>([
    {
      title: 'Overview',
      icon: 'dashboard-outline',
      active: true,
      disabled: false,
      component: <OverviewTab />,
    },
    {
      title: 'Company',
      icon: 'business',
      active: false,
      disabled: false,
      component: <CompanyTab />,
    },
    {
      title: 'Billing',
      icon: 'billing',
      active: false,
      disabled: true,
      component: <BillingTab />,
    },
    {
      title: 'Users',
      icon: 'groups-outlined',
      active: false,
      disabled: false,
      component: <UsersTab />,
    },
    // {
    //   title: 'Invoice',
    //   icon: 'credit-card-bold',
    //   active: false,
    //   disabled: false,
    //   component: <InvoiceTab />,
    // },
  ]);

  const activeTab = tabs.find((i) => i.active);
  const isUsersTab = activeTab?.title === 'Users';

  const handleChangeTabs = (tab: Tab) => {
    setTabs((prev) => {
      const isAlreadyActive = prev.find((t) => t.title === tab.title)?.active;
      if (isAlreadyActive) return prev;

      return prev.map((t) => ({
        ...t,
        active: t.title === tab.title,
      }));
    });
  };

  const headerTitle =
    activeTab?.title === 'Overview'
      ? 'Account Information'
      : activeTab?.title === 'Company'
      ? 'Company Information'
      : activeTab?.title === 'Users'
      ? 'Users Information'
      : 'Information';

  return (
    <ChangeProvider>
      <Styled.Wrapper
        className={classnames('AccountManagementDrawer', className)}
        sx={SX.root}
        state={sidebarState}
        handleChangeTabs={handleChangeTabs}
        header={
          <HeaderNavigation drawerState={sidebarState} title={headerTitle} />
        }
        subHeader={
          <InformationCard data={user} showAccountStatus={isUsersTab} />
        }
        footer={<FooterNavigation />}
        tabs={tabs}
        tabContent={activeTab?.component ?? <div />}
        onClose={onCloseSidebar}
        width={460}
      />
    </ChangeProvider>
  );
});

AccountManagementDrawer.displayName = 'AccountManagementDrawer';
